import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJob.Find.IRequest;
type Response = Api.Core.ClaimJob.Find.IResponse;
type Headers = Api.Core.ClaimJob.Find.IHeaders;
const url = '/api/Claims/ClaimJob/:id';
export default async function claimJobFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
